import { render, staticRenderFns } from "./assignSealerDialog.vue?vue&type=template&id=5005292b&scoped=true&"
import script from "./assignSealerDialog.vue?vue&type=script&lang=js&"
export * from "./assignSealerDialog.vue?vue&type=script&lang=js&"
import style0 from "./assignSealerDialog.vue?vue&type=style&index=0&id=5005292b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5005292b",
  null
  
)

export default component.exports